<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M12 7.19999c-.6365 0-1.247-.25285-1.6971-.70294-.45007-.45009-.70292-1.06054-.70292-1.69706s.25285-1.24697.70292-1.69705c.4501-.45009 1.0606-.70295 1.6971-.70295.6365 0 1.2469.25286 1.697.70295.4501.45008.703 1.06053.703 1.69705s-.2529 1.24697-.703 1.69706c-.4501.45009-1.0605.70294-1.697.70294ZM12 14.4c-.6365 0-1.247-.2529-1.6971-.7029-.45007-.4501-.70292-1.0606-.70292-1.6971 0-.6365.25285-1.247.70292-1.6971.4501-.45005 1.0606-.70291 1.6971-.70291.6365 0 1.2469.25286 1.697.70291.4501.4501.703 1.0606.703 1.6971 0 .6365-.2529 1.247-.703 1.6971-.4501.45-1.0605.7029-1.697.7029Zm0 7.2c-.6365 0-1.247-.2529-1.6971-.7029-.45007-.4501-.70292-1.0606-.70292-1.6971 0-.6365.25285-1.247.70292-1.6971.4501-.45 1.0606-.7029 1.6971-.7029.6365 0 1.2469.2529 1.697.7029.4501.4501.703 1.0606.703 1.6971 0 .6365-.2529 1.247-.703 1.6971-.4501.45-1.0605.7029-1.697.7029Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3c.5304 0 1.0391.21071 1.4142.58579C13.7893 3.96086 14 4.46957 14 5s-.2107 1.03914-.5858 1.41421C13.0391 6.78929 12.5304 7 12 7c-.5304 0-1.0391-.21071-1.4142-.58579C10.2107 6.03914 10 5.53043 10 5s.2107-1.03914.5858-1.41421Zm0 7.00001C10.9609 10.2107 11.4696 10 12 10c.5304 0 1.0391.2107 1.4142.5858S14 11.4696 14 12c0 .5304-.2107 1.0391-.5858 1.4142S12.5304 14 12 14c-.5304 0-1.0391-.2107-1.4142-.5858S10 12.5304 10 12c0-.5304.2107-1.0391.5858-1.4142Zm0 7C10.9609 17.2107 11.4696 17 12 17c.5304 0 1.0391.2107 1.4142.5858S14 18.4696 14 19c0 .5304-.2107 1.0391-.5858 1.4142S12.5304 21 12 21c-.5304 0-1.0391-.2107-1.4142-.5858S10 19.5304 10 19c0-.5304.2107-1.0391.5858-1.4142Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
